define((require) => {
    "use strict";

    const AbstractWidgetView  = require("shared/ui/experience/widgets/AbstractWidgetView");
    const $                   = require("jquery");
    const {extend}            = require("underscore");
    const StyleableMixin      = require("shared/ui/experience/widgets/StyleableMixin");
    const Color               = require("shared/util/Color");
    const ButtonWidgetHelper  = require("shared/ui/experience/widgets/button/ButtonWidgetHelper");
    const ButtonIconModel     = require("shared/ui/experience/widgets/button/ButtonIconModel");
    const ButtonType          = require("shared/ui/experience/widgets/button/ButtonType");
    const WebFontsUtil        = require("shared/ui/experience/fonts/WebFontsUtil");

    return AbstractWidgetView.extend("ButtonWidgetView", {

        className: `${AbstractWidgetView.prototype.className} button-widget`,

        mixin: StyleableMixin,

        _$container: null,

        _$label: null,

        _$icon: null,

        modelEvents: extend(AbstractWidgetView.prototype.modelEvents, {
            "change:icon": "render"
        }),

        options: {
            fetchIcon: ButtonWidgetHelper.fetchIcon
        },

        onInitialize(element) {
            this._$container = $("<button></button>")
                .attr("type", "button");
            this._$label = $(`<span></span>`);
            this._$icon = $("<span></span>");

            this._$label.css({
                whiteSpace: "nowrap",
                overflow: "hidden"
            });

            this._$container.css({
                userSelect: "none",
                pointerEvents: "none",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                backgroundColor: "transparent"
            });
            element.append(this._$container);
        },

        updateRendering(element, bounds, active, edited) {
            const attributes = this.model.attributes;
            const buttonType = attributes.buttonType;

            this._$container.empty();

            element.attr("data-button-type", buttonType);

            let fontFamily = null;

            if (buttonType !== ButtonType.ICON_ONLY) {
                const unquotedFontFamily = WebFontsUtil.getCssFontFamily(this.model);
                if (unquotedFontFamily) {
                    fontFamily = WebFontsUtil.quoteSpecialFontNames(unquotedFontFamily);
                }
            }

            const buttonCss = {
                lineHeight: "1.4",
                padding: `6px ${attributes.padding}px`,
                color: attributes.color,
                fontFamily,
                fontStyle: attributes.fontStyle,
                fontWeight: attributes.fontWeight,
                fontSize: `${parseInt(attributes.fontSize, 10)}px`,
                border: "0",
                minWidth: attributes.fontSize,
                minHeight: attributes.fontSize
            };

            if (buttonType === ButtonType.ICON_ONLY) {
                buttonCss.padding = attributes.padding;
            }

            const iconModel = attributes.icon;
            switch (attributes.buttonType) {
                case ButtonType.ICON_ONLY:
                    this._$label.text("");
                    this.$el.attr("aria-label", iconModel.get("name"));
                    this._$container.append(this._$icon);
                    this._setupIcon();
                    break;
                case ButtonType.TEXT_AND_ICON:
                    this._$label.text(attributes.label);
                    this.$el.attr("aria-label", attributes.label);
                    if (iconModel.get("placement") === ButtonIconModel.Placement.AFTER) {
                        this._$container.append(this._$label);
                        this._$container.append(this._$icon);
                    } else {
                        this._$container.append(this._$icon);
                        this._$container.append(this._$label);
                    }
                    this._setupIcon();
                    break;
                case ButtonType.TEXT_ONLY:
                    this._$label.text(attributes.label);
                    this.$el.attr("aria-label", attributes.label);
                    this._$container.append(this._$label);
                    break;
                default:
                    throw new Error(`unexpected button type: '${attributes.buttonType}'`);
            }

            const buttonActive = !edited;

            if (buttonActive) {
                this._setupMouseEffect(element);
            }

            element.toggleClass("active", buttonActive);
            this._$container.css(buttonCss);
            this._$container.attr("title", this.model.get("title"));
        },

        _setupIcon() {
            const buttonSize = this.model.get("fontSize");

            this._$icon.css({
                width: buttonSize,
                height: buttonSize,
                lineHeight: 0
            });

            const iconModel = this.model.get("icon");
            this.options.fetchIcon(iconModel).then((svg) => {
                const fontSize = this.model.get("fontSize");
                $(svg)
                    .css({
                        fill: iconModel.get("color")
                    })
                    .attr("width", fontSize)
                    .attr("height", fontSize)
                    .attr("aria-labelledby", "title");

                const $title = $("<title></title>")
                    .text(iconModel.get("name"));

                $(svg).prepend($title);

                this._$icon.empty();
                this._$icon.append(svg);
                const buttonType = this.model.get("buttonType");

                if (buttonType === ButtonType.TEXT_AND_ICON) {
                    if (iconModel.get("placement") === ButtonIconModel.Placement.AFTER) {
                        this._$icon.css({
                            "margin-left": 5,
                            "margin-right": 0
                        });
                        this._$container.append(this._$icon);
                    } else {
                        this._$icon.css({
                            "margin-left": 0,
                            "margin-right": 5
                        });
                        this._$container.prepend(this._$icon);
                    }
                } else {
                    this._$icon.css({
                        "margin-left": 0,
                        "margin-right": 0
                    });
                }

                // Good practice for async rendering - also needed for WidgetCollectionView
                // to proper update transform controls when in the editor.
                this.trigger("update");
            });
        },

        _setupMouseEffect(element) {
            const backgroundColor = this.model.get("backgroundColor");

            if (!backgroundColor.length) {
                return;
            }

            const hoverColor = Color.hexToRgba(backgroundColor, 0.75);
            const downColor = Color.hexToRgba(backgroundColor, 0.95);

            element
                .mouseenter(() => {
                    element.css("backgroundColor", hoverColor);
                })
                .mousedown(() => {
                    element.css("backgroundColor", downColor);
                })
                .mouseup(() => {
                    element.css("backgroundColor", hoverColor);
                })
                .mouseleave(() => {
                    element.css("backgroundColor", backgroundColor);
                });
        }

    });
});



// WEBPACK FOOTER //
// ./src/shared/ui/experience/widgets/button/ButtonWidgetView.js